import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE_react_hook_form_05a66946__ from "react-hook-form";
import * as __WEBPACK_EXTERNAL_MODULE__nestle_npus_nbm_purina_auth_11a881f8__ from "@nestle-npus-nbm/purina-auth";
import * as __WEBPACK_EXTERNAL_MODULE__api_index_mjs_744ca914__ from "../../../../api/index.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__common_constants_mjs_a4a44cfd__ from "../../../../common/constants.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__common_functions_mjs_af6dcd47__ from "../../../../common/functions.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__hooks_index_mjs_3fb73dfc__ from "../../hooks/index.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__Dialog_Dialog_mjs_3c053368__ from "../Dialog/Dialog.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__components_Checkbox_mjs_0926c3b5__ from "./_components/Checkbox.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__components_FormSubscript_mjs_ee8b580b__ from "./_components/FormSubscript.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__components_OptInLabel_mjs_21e2b217__ from "./_components/OptInLabel.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__components_pds_ui_Button_mjs_80029441__ from "./_components/pds-ui/Button.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__components_pds_ui_Input_mjs_9a408f8b__ from "./_components/pds-ui/Input.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__components_PetCount_mjs_a023f77f__ from "./_components/PetCount.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__common_awsSettings_mjs_9db78727__ from "../../../../common/awsSettings.mjs";
const POSTAL_CODE_REG_EXP = new RegExp(/^([A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d|[0-9]{5}(?:-[0-9]{4})?)$/);
const CompleteProfile = ({ config = __WEBPACK_EXTERNAL_MODULE__common_constants_mjs_a4a44cfd__.defaultPurinaProfileConfig, isOpen })=>{
    const [isLoading, setIsLoading] = __WEBPACK_EXTERNAL_MODULE_react__["default"].useState(false);
    const [shouldRefetchUser, setShouldRefetchUser] = __WEBPACK_EXTERNAL_MODULE_react__["default"].useState(false);
    const Auth = __WEBPACK_EXTERNAL_MODULE_react__["default"].useMemo(()=>(0, __WEBPACK_EXTERNAL_MODULE__nestle_npus_nbm_purina_auth_11a881f8__.profileAuth)({
            cognito: (0, __WEBPACK_EXTERNAL_MODULE__common_awsSettings_mjs_9db78727__.getAwsSettings)(config.cognito).Auth,
            pup: {
                url: config.pup.url
            }
        }), [
        config.cognito
    ]);
    const { user, mutate: refreshUser } = (0, __WEBPACK_EXTERNAL_MODULE__hooks_index_mjs_3fb73dfc__.useGetUser)(config, !shouldRefetchUser);
    const { attributes, accessToken, mutate: refreshToken } = (0, __WEBPACK_EXTERNAL_MODULE__hooks_index_mjs_3fb73dfc__.useGetCognitoUser)(config);
    const { neededValidations } = (0, __WEBPACK_EXTERNAL_MODULE__hooks_index_mjs_3fb73dfc__.useProfileValidations)(config);
    const { register, handleSubmit, formState, control, watch, trigger, reset, getValues, setValue } = (0, __WEBPACK_EXTERNAL_MODULE_react_hook_form_05a66946__.useForm)({
        mode: 'onChange',
        defaultValues: {
            postalCode: neededValidations.hasZipcode ? void 0 : '',
            termsAndConditions: false,
            dogCount: '',
            catCount: ''
        }
    });
    const termsAndConditions = watch('termsAndConditions');
    __WEBPACK_EXTERNAL_MODULE_react__["default"].useEffect(()=>{
        if (formState.dirtyFields.termsAndConditions) trigger('termsAndConditions');
    }, [
        trigger,
        termsAndConditions,
        formState.dirtyFields.termsAndConditions
    ]);
    const sstService = __WEBPACK_EXTERNAL_MODULE_react__["default"].useMemo(()=>new __WEBPACK_EXTERNAL_MODULE__api_index_mjs_744ca914__.SstServices({
            baseUrl: (0, __WEBPACK_EXTERNAL_MODULE__common_functions_mjs_af6dcd47__.getApiUrl)(config.cognito.oauth.domain),
            baseApiParams: {
                secure: true
            },
            securityWorker: (securityData)=>{
                if (securityData) return {
                    headers: {
                        Authorization: securityData.token
                    }
                };
            }
        }), [
        config.pup.url
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__["default"].useEffect(()=>{
        if (config.pup.theme) {
            const { primary, primaryAction, primaryActive, text } = config.pup.theme;
            const root = document.querySelector(':root');
            root?.style.setProperty('--ptw-theme-primary', primary);
            root?.style.setProperty('--ptw-theme-primary-action', primaryAction);
            root?.style.setProperty('--ptw-theme-primary-active', primaryActive);
            root?.style.setProperty('--ptw-theme-text', text);
        }
    }, [
        config.pup.theme
    ]);
    const onSubmit = async (data)=>{
        const updateUser = async (updateUserPayload)=>{
            if (accessToken) sstService.setSecurityData({
                token: accessToken
            });
            return sstService.updateUserSstServicesV1UsersUserIdPut(attributes?.[__WEBPACK_EXTERNAL_MODULE__nestle_npus_nbm_purina_auth_11a881f8__.legacyIdTokenPayloadKeys.ansiraId], updateUserPayload);
        };
        const updateUserPayload = {
            id: attributes?.[__WEBPACK_EXTERNAL_MODULE__nestle_npus_nbm_purina_auth_11a881f8__.legacyIdTokenPayloadKeys.ansiraId],
            email: attributes?.[__WEBPACK_EXTERNAL_MODULE__nestle_npus_nbm_purina_auth_11a881f8__.legacyIdTokenPayloadKeys.email],
            dogCount: data.dogCount ? Number(data.dogCount) : void 0,
            catCount: data.catCount ? Number(data.catCount) : void 0,
            sourceCode: {
                keyName: config.analytics?.updateSourceCode || 'PUPurinaUniversalUpdate',
                id: 55555
            }
        };
        if (data.termsAndConditions) updateUserPayload.tAndC = data.termsAndConditions;
        if (data.postalCode) updateUserPayload.address = {
            ...user?.address || {},
            postalCode: data.postalCode.toUpperCase()
        };
        await updateUser(updateUserPayload);
        if (config.analyticsEventHandlers?.handleCreateAccountEvent) config.analyticsEventHandlers?.handleCreateAccountEvent();
        else (0, __WEBPACK_EXTERNAL_MODULE__common_functions_mjs_af6dcd47__.sendIt)({
            event: 'form_complete',
            eventParams: {
                form_name: 'create account opt-in',
                form_type: 'sign-up',
                form_brand: config.analytics?.formBrand ?? '[not set]',
                form_id: config?.analytics?.loginSourceCode ?? '[not set]',
                form_parent: config.analytics?.formParent ?? '[not set]'
            }
        }, config.pup.dataLayerName, config.pup.logging);
        setShouldRefetchUser(true);
    };
    __WEBPACK_EXTERNAL_MODULE_react__["default"].useEffect(()=>{
        if (shouldRefetchUser) {
            setIsLoading(true);
            Auth.refreshUser().then(()=>Promise.all([
                    refreshUser(),
                    refreshToken()
                ]).finally(()=>{
                    setShouldRefetchUser(false);
                    reset();
                    setIsLoading(false);
                }));
        }
    }, [
        shouldRefetchUser,
        refreshUser,
        refreshToken,
        reset,
        Auth
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: "purina-profile ptw-font-sans",
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__Dialog_Dialog_mjs_3c053368__.Dialog, {
            open: isOpen,
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__Dialog_Dialog_mjs_3c053368__.DialogContent, {
                container: 'undefined' == typeof window ? null : document.body,
                showClose: false,
                className: "ptw-fixed ptw-top-0 ptw-z-[7001] ptw-h-[100dvh] ptw-w-full ptw-overflow-y-auto ptw-overflow-x-hidden ptw-bg-[#fff] ptw-px-4 ptw-font-sans ptw-text-surface-text",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("form", {
                    onSubmit: handleSubmit(onSubmit),
                    className: "ptw-mx-auto ptw-mt-5 ptw-max-w-[400px] [&>*]:ptw-mb-4",
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("h2", {
                            className: "ptw-text-title-md ptw-font-extrabold",
                            children: "Please complete your profile"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                            className: "ptw-text-center",
                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                className: "ptw-font-semibold",
                                children: "How many dogs and/or cats do you have?"
                            })
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                            className: "ptw-flex ptw-gap-3",
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__components_PetCount_mjs_a023f77f__["default"], {
                                    petType: "dog",
                                    register: register,
                                    getValues: getValues,
                                    setValue: setValue,
                                    formState: formState
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__components_PetCount_mjs_a023f77f__["default"], {
                                    petType: "cat",
                                    register: register,
                                    getValues: getValues,
                                    setValue: setValue,
                                    formState: formState
                                })
                            ]
                        }),
                        !neededValidations.hasZipcode && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__components_pds_ui_Input_mjs_9a408f8b__.Input, {
                                    "data-error": Boolean(formState.errors.postalCode),
                                    type: "text",
                                    label: "ZIP/Postal Code",
                                    ...register('postalCode', {
                                        required: 'ZIP/Postal Code is required',
                                        pattern: {
                                            value: POSTAL_CODE_REG_EXP,
                                            message: 'Must enter valid US ZIP or CA Postal Code.'
                                        }
                                    })
                                }),
                                formState.errors.postalCode && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("span", {
                                    className: "ptw-text-error-base",
                                    children: [
                                        String(formState.errors?.postalCode?.message),
                                        'pattern' === formState.errors.postalCode.type && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
                                            children: " ex: 55555 or A1A\xa01A1"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__components_FormSubscript_mjs_ee8b580b__["default"], {
                                    children: "ZIP/Postal Code is used to verify your location and personalize your experience."
                                })
                            ]
                        }),
                        !neededValidations.hasTandC && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_hook_form_05a66946__.Controller, {
                                    name: "termsAndConditions",
                                    control: control,
                                    rules: {
                                        required: 'Please accept terms and conditions'
                                    },
                                    render: ({ field: { onChange, value } })=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__components_Checkbox_mjs_0926c3b5__.Checkbox, {
                                            "data-error": Boolean(formState.errors.termsAndConditions),
                                            id: "terms",
                                            onCheckedChange: onChange,
                                            checked: value,
                                            required: true,
                                            position: "top",
                                            label: ()=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__components_OptInLabel_mjs_21e2b217__["default"], {})
                                        })
                                }),
                                formState.errors.termsAndConditions && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                    className: "ptw-text-error-base",
                                    children: formState.errors?.termsAndConditions?.message
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__components_pds_ui_Button_mjs_80029441__.Button, {
                            disabled: !formState.isDirty || !formState.isValid || formState.isSubmitting || isLoading,
                            className: "ptw-my-4 ptw-border-none ptw-bg-primary-base ptw-font-bold ptw-text-primary-text hover:ptw-bg-primary-active disabled:ptw-bg-disabled-base disabled:ptw-text-disabled-text",
                            width: "full",
                            type: "submit",
                            children: formState.isSubmitting ? 'Submitting...' : 'Submit'
                        })
                    ]
                })
            })
        })
    });
};
CompleteProfile.displayName = 'CompleteProfile';
export { CompleteProfile };
